import React from "react";
import { Box, Typography, Card, CardContent, Divider, Grid } from "@mui/material";

const CallHistory = ({ candidate }) => {
    return (
        <Box sx={{ padding: 1 , marginTop: 2,marginBottom:0 }}>
            
            <Divider sx={{ marginBottom: 2 }} />

            {/* Candidate Information */}
            <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "#f9f9f9", marginBottom: 2 }}>
                <CardContent>
                    <Typography variant="h5" fontWeight="bold" gutterBottom sx={{fontSize:"15px"}}>
                        Name : {candidate.name}
                    </Typography>
                   
                    <Typography variant="body1" sx={{ fontSize: "15px" }}><strong>Phone Number:</strong> {candidate.phoneno}</Typography>
                </CardContent>
            </Card>

            {/* Call History Details */}
            <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "#f9f9f9" }}>
                <CardContent>
                   
                    <Grid container spacing={2}>
                        {candidate.history?.length > 0 ? (
                            candidate.history.map((call, index) => (
                                <Grid item xs={12} key={index}>
                                    <Box sx={{ padding: 2, border: "1px solid #e0e0e0", borderRadius: 2, bgcolor: "#fff", marginBottom: 2 }}>
                                        <Typography variant="body1"><strong>Date:</strong> {call.date}</Typography>
                                        <Typography variant="body1"><strong>Time:</strong> {call.time}</Typography>
                                        <Typography variant="body1"><strong>Status:</strong> {call.status}</Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            <strong>Notes:</strong> {call.notes}
                                        </Typography>

                                        {/* Audio Player Always Visible */}
                                        {call.recording && (
                                            <audio controls style={{ width: "100%", marginTop: "10px" }}>
                                                <source src={call.recording} type="audio/mpeg" />
                                                Your browser does not support the audio element.
                                            </audio>
                                        )}
                                    </Box>
                                </Grid>
                            ))
                        ) : (
                            <Typography variant="body2" color="textSecondary">
                                No call history available for this candidate.
                            </Typography>
                        )}
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    );
};

export default CallHistory;
